import { createContext } from "react";

/**
 * Whether the page's filters narrow the lists, and how to clear them.
 * `narrowed` counts every filter except the date range; `widenPeriod` is set
 * when only the dates narrow the view and they are not yet the widest range.
 */
export const WhatsappFilterContext = createContext<{
  filtered: boolean;
  clear?: () => void;
  narrowed?: boolean;
  widenPeriod?: () => void;
}>({
  filtered: false,
});
